<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M4.5 3H2C1.44772 3 1 3.44772 1 4V14C1 14.5523 1.44772 15 2 15H14C14.5523 15 15 14.5523 15 14V4C15 3.44772 14.5523 3 14 3H11.5M4.5 3H5C5.55228 3 6 2.55228 6 2V2C6 1.44772 6.44772 1 7 1H9C9.55228 1 10 1.44772 10 2V2C10 2.55228 10.4477 3 11 3H11.5M4.5 3V5C4.5 5.55228 4.94772 6 5.5 6H10.5C11.0523 6 11.5 5.55228 11.5 5V3"
        stroke="var(--icon-color)" stroke-width="2" />
</svg>
